export const ENCTYPE = {
  BOUNDARY: 'multipart/form-data; boundary=----WebKitFormBoundaryuL67FWkv1CA'
};
